<section class="mdt-type-decision-wrapper">
    <gen-dynamic-form
      class="mdtTypeDecision"
      [disabled]="false"
      [formVertical]="true"
      [formConfig]="inputConfig"
      [resetForm]="false"
      [editMode]="false"
      (formChange)="updateFormOnChange($event.form, $event.updated)"
      (validateChange)="updateValidate($event)"
      [popupMode]="true"
      [stayInFormMode]="true"
      [listenToDataChange]="true"
      [submitted]="submitted"
      [emitFormChangeEvenIfInvalid]="true"
    ></gen-dynamic-form>
  </section>
